<template>
  <div class="h-full w-full p-10px bg-[#fff]">
    <el-row :gutter="10" class="mb-10px">
      <el-col :span="4">
        <div
          class="border-l-[3px] border-solid border-[var(--buttonPrimaryBg)] pl-10px mb-10px flex justify-between items-center"
        >
          <span>计划目录树</span>
        </div>
      </el-col>
      <el-col :span="20">
        <div>
          <el-input
            class="mr-10px !w-150px"
            clearable
            v-model="search.keyword"
            placeholder="请输入关键字"
          ></el-input>
          <el-select placeholder="请选择创建人员" v-model="search.createperson"   class="mr-10px !w-150px">
            <el-option></el-option>
          </el-select>
          <el-date-picker
            v-model="search.date"
            type="daterange"
            class="mr-10px !w-230px"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <el-select   class="mr-10px !w-150px" v-model="search.unitId" placeholder="请选择机组系统">
            <el-option></el-option>
          </el-select>
          <el-select   class="mr-10px !w-160px" v-model="search.state" placeholder="请选择里程碑状态">
            <el-option value="草稿">草稿</el-option>
            <el-option value="已发布">已发布</el-option>
          </el-select>
          <el-button class="mr-10px" type="primary" @click="searchList"> 搜索</el-button>
          <el-button class="mr-10px" type="primary" @click="resetSearch"> 重置</el-button>
          <el-button class="mr-10px" type="primary" @click="operate()"> 新增</el-button>

          <el-button type="danger" @click="deleteAny"   class="mr-10px"> 删除</el-button>
          <el-button class="mr-10px" @click="importData()"> 导入</el-button>
          <el-button class="mr-10px" @click="exportData()"> 导出</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="h-[calc(100%-50px)]">
      <el-col :span="4" class="h-full">
        <div class="w-full flex">
          <div class="!w-2/3 mr-20px">
            <el-input  prefix-icon="el-icon-search" placeholder="请输入计划名称" v-model="planName">
            </el-input>
          </div>
          <el-button type="primary">搜索</el-button>
        </div>
        <div class="h-[calc(100%-50px)] overflow-auto">
          <el-menu class="h-full">
            <el-menu-item
              @click="changePlan(item)"
              v-for="(item, index) in projectScheduleList"
              :index="index"
              :key="index"
            >
              {{ item.name }}
            </el-menu-item>
          </el-menu>
        </div>
      </el-col>
      <el-col :span="20" class="h-full">
        <el-table
          :data="tableData"
          border
          height="calc(100% - 60px)"
          stripe
          v-loading="loading"
          ref="tableRef"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column type="index" label="序号" :width="60"></el-table-column>
          <el-table-column
            v-for="(item, index) in columns"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed || false"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="操作" align="left" width="200px" fixed="right">
            <template slot-scope="scope">
              <div>
                <el-button class="mr-10px" size="mini" @click="operate(scope.row, 'view')"
                  >查看</el-button
                >
                <el-button class="mr-10px" size="mini" @click="operate(scope.row, 'edit')"
                  >编辑</el-button
                >
                <el-button size="mini" @click="deleteItem(scope.row)">删除</el-button>
              </div>
            </template></el-table-column
          >
        </el-table>
        <div class="text-right mt-10px">
          <el-pagination
            background
            @size-change="getList()"
            @current-change="getList()"
            :current-page.sync="page.no"
            :page-size.sync="page.size"
            :page-sizes="[10, 15, 20, 30, 50, 100]"
            layout="total, sizes, prev, pager, next"
            :total="page.total"
          ></el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  components: {},
  data() {
    return {
      projectScheduleList: [
        {
          id: 1,
          name: '11',
        },

        {
          id: 2,
          name: '11',
        },
        {
          id: 2,
          name: '11',
        },
        {
          id: 1,
          name: '11',
        },
        {
          id: 1,
          name: '11',
        },
        {
          id: 1,
          name: '11',
        },
        {
          id: 1,
          name: '11',
        },
        {
          id: 1,
          name: '11',
        },
        {
          id: 1,
          name: '11',
        },
        {
          id: 2,
          name: '11',
        },
        {
          id: 1,
          name: '11',
        },
        {
          id: 1,
          name: '11',
        },
        {
          id: 1,
          name: '11',
        },
        {
          id: 1,
          name: '11',
        },
        {
          id: 1,
          name: '11',
        },
        {
          id: 1,
          name: '11',
        },
      ],
      planName: '',
      currentPlan: null,
      search: {
        keyword: '',
        date: [],
        unitId: '',
        state: '',
        createperson: '',
      },
      columns: [
        { prop: 'name', label: '里程碑名称', width: 200 },
        { prop: 'code', label: '里程碑任务编码', width: 180 },
        { prop: 'startTime', label: '计划开始日期' },
        { prop: 'endTime', label: '计划完成日期' },
        { prop: 'period', label: '工期' },
        { prop: 'creator', label: '创建人' },
        { prop: 'createTime', label: '创建时间' },
        { prop: 'state', label: '里程碑状态' },
      ],
      loading: true,
      tableData: [],
      checkList: [],
      page: {
        no: 1,
        size: 20,
        total: 0,
      },
    }
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  methods: {
    async getList() {
      this.loading = true

      this.loading = false
    },
    resetSearch() {
      this.Keyword = ''
      this.tableData = []
      this.page.no = 1
      this.getList()
    },
    searchList() {
      this.page.no = 1
      this.tableData = []
      this.getList()
    },
    changePlan(val) {
      this.currentPlan = val
    },
    importData() {},
    exportData() {},
    operate(row, mode) {
      this.$router.push({
        path: `${this.basePath}/construction-schedule-management/milestone-detail`,
        query: {
          mode,
          id: row?.id,
        },
      })
    },
    async deleteItem(row) {
      this.$confirm(this.$t('是否确定删除?'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'warning',
      }).then(async () => {})
    },

    edit(row) {},
    closeDialog() {},

    handleSelectionChange(val) {
      this.checkList = val.map((o) => {
        return o.id
      })
    },
    // eslint-disable-next-line consistent-return
    deleteAny() {
      if (this.checkList.length === 0) return this.$message.warning('至少选择一个里程碑！')
      this.$confirm('是否删除选中计划！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false,
      }).then(async () => {})
    },
  },
  mounted() {
    this.getList()
  },
  destroyed() {},
}
</script>

<style>
</style>
